export const navItems = [
  { label: '首页', href: '/' },
  { label: '关于华辉', href: '/about' },
  { label: '投资与合作', href: '/invest' },
];

export const projectMenu = [
  { label: '0#首发', href: '/launch' },
  { label: '千县万村', href: '/scale' },
  { label: '产品矩阵', href: '/products' },
  { label: '证据中心', href: '/evidence' },
];

export const jiuchouMenu = [
  { label: '九畴云市总览', href: '/jiuchou' },
  { label: '五层平台架构', href: '/jiuchou/architecture' },
  { label: '一条业务主链', href: '/jiuchou/chain' },
  { label: '数字商业节点', href: '/jiuchou/yun-node' },
  { label: '供应链与服务', href: '/jiuchou/supply-service' },
  { label: '消费与权益', href: '/jiuchou/consumption' },
  { label: '透明清分账本', href: '/jiuchou/settlement' },
  { label: '数据飞轮与AI', href: '/jiuchou/data-ai' },
  { label: '体验九畴云市', href: '/experience' },
];

export const heroDataCards = [
  { code: '0#', label: '城市验证场景', name: '帝星数商综合体' },
  { code: '1#', label: '乡村复制场景', name: '大庄科样板间' },
  { code: 'N#', label: '规模化复制', name: '从单点走向千县万村' },
];

export const policyBase = [
  { title: '乡村振兴', desc: '产业振兴 · 消费振兴 · 人才振兴 · 组织振兴' },
  { title: '数字乡村', desc: '数字农业 · 农村电商 · 农产品上行' },
  { title: '县域商业', desc: '县乡村商业体系 · 供应链 · 农村消费' },
  { title: '数字经济 / 数据要素', desc: '数据资源 · 数据流通 · 数据价值' },
];

export const applicationSystems = [
  { title: 'AI 智能服务', desc: 'TOMA 智能体 · 健康管家 · 数字服务' },
  { title: '县域数字商业', desc: '数字货架 · 云铺 · 商户数字化' },
  { title: '农业产业流通', desc: 'ePin 溯源 · 农产品数字化上行' },
  { title: '数据要素与数字消费', desc: '红包 · 权益 · 消费数据' },
];

export const comparison = [
  { traditional: '商品分散', jiuchou: '数字货架集中' },
  { traditional: '信息不对称', jiuchou: '数据连接' },
  { traditional: '农产品销售难', jiuchou: '农产品数字化上行' },
  { traditional: '小店缺流量', jiuchou: '云社员协同' },
  { traditional: '小店缺资金', jiuchou: '信用进货机制' },
  { traditional: '服务依赖人工', jiuchou: 'TOMA 智能服务' },
  { traditional: '数据无法沉淀', jiuchou: 'ePin 数字身份' },
  { traditional: '多方结算复杂', jiuchou: '智能清分' },
  { traditional: '城乡市场割裂', jiuchou: '城乡消费协同' },
];

export const launch0Stats = [
  { value: '4万+', label: '帝星存量会员种子用户' },
  { value: '1000', label: '首批消费卡' },
  { value: '10000', label: '满额发行规模' },
  { value: '10—20', label: '首批数字货架商品' },
  { value: '99', label: '同步启动云创客招募' },
  { value: '3秒', label: '项目设定的红包到账目标' },
];

export const productShowcase = {
  items: [
    {
      name: '智能视觉监控',
      en: 'Vision Monitoring',
      desc: '4K 超清成像与智能人形/车辆侦测，支持太阳能供电与 4G 无线回传，无电无网环境也能快速部署，全天候守护县域街道、园区与乡村道路。',
      href: '/products',
      icon: 'ri-camera-lens-line',
      image:
        'https://public.readdy.ai/ai/img_res/edited_0586058cac92e6e55ed3d0eb5fd8e469_e77827cd.jpg',
    },
    {
      name: '商用显示',
      en: 'Commercial Display',
      desc: '数字标牌、拼接大屏与交互触控一体化，云端远程投放与定时排期，从门店橱窗到指挥中心，构建多样化的数字展示能力。',
      href: '/products',
      icon: 'ri-tv-2-line',
      image:
        'https://public.readdy.ai/ai/img_res/edited_8b19f47d21364063bc410be718485a02_7728bedb.jpg',
    },
    {
      name: '智慧物联',
      en: 'IoT Sensing',
      desc: '水电计量、环境监测与消防感知全覆盖，低功耗无线组网与远程数据上云，构建城市与县域的感知数据底座。',
      href: '/products',
      icon: 'ri-wifi-line',
      image:
        'https://public.readdy.ai/ai/img_res/edited_f67eac03b6e46fa7534b388c90488c88_48c589a9.jpg',
    },
  ],
};